import React from 'react';

const BookRoundIllustrationSvg = (props) => (
    <svg viewBox="0 0 120 120" {...props}>
        <defs>
            <style>
                {
                    '.book-round-illustration_svg__eds-book-open-cls-2{fill:#783c5a}.book-round-illustration_svg__eds-book-open-cls-3{fill:#f6f9ff}.book-round-illustration_svg__eds-book-open-cls-4{fill:#a9a8b3}.book-round-illustration_svg__eds-book-open-cls-6{fill:#fff}'
                }
            </style>
        </defs>
        <circle cx={60.02} cy={60} r={49} fill="#82d2dc" />
        <path
            className="book-round-illustration_svg__eds-book-open-cls-2"
            d="M105.94 71.88L94.3 18.14a.57.57 0 0 0-.68-.44l-37.05 8c-1.8.39-5.62 4.21-6.75 5.37-1.5-.59-6.54-2.49-8.33-2.1L4.39 37a.58.58 0 0 0-.44.68l11.64 53.81a.55.55 0 0 0 .25.36.57.57 0 0 0 .31.1h.12l37.12-8a3.23 3.23 0 0 0 3.84 2.43l8.44-1.83a3.23 3.23 0 0 0 2.43-3.81l37.4-8.12a.57.57 0 0 0 .44-.74z"
        />
        <path
            className="book-round-illustration_svg__eds-book-open-cls-3"
            d="M103 70.6l-35.42 7.66c-1.8.39-6.41 5.29-6.41 5.29s-6.2-2.56-8-2.17l-35.42 7.67L6.48 37l35.43-7.67c1.8-.39 8 2.17 8 2.17s4.6-4.9 6.41-5.29l35.38-7.63z"
        />
        <path
            className="book-round-illustration_svg__eds-book-open-cls-4"
            d="M101.17 69.09L67 76.5c-1.74.38-6.19 5.11-6.19 5.11s-6-2.47-7.73-2.1l-34.32 7.43-10.89-50.3 34.26-7.42c1.74-.38 7.73 2.1 7.73 2.1s4.45-4.74 6.19-5.11l34.22-7.41z"
        />
        <path
            className="book-round-illustration_svg__eds-book-open-cls-3"
            d="M99.14 67.23l-32.93 7.14c-1.68.36-6 4.94-6 4.94s-5.77-2.4-7.45-2l-33 7.14L9.31 35.78l33-7.14c1.67-.36 7.45 2 7.45 2s4.28-4.57 6-4.94l32.85-7.1z"
        />
        <path
            className="book-round-illustration_svg__eds-book-open-cls-4"
            d="M15.8 42.07a.53.53 0 0 1-.51-.41.52.52 0 0 1 .4-.62l24.66-5.34a.52.52 0 1 1 .22 1l-24.66 5.36zM17.28 48.93a.53.53 0 0 1-.51-.41.52.52 0 0 1 .4-.62l21-4.54a.52.52 0 1 1 .22 1l-21 4.54zM18.77 55.79a.53.53 0 0 1-.51-.41.52.52 0 0 1 .4-.62l24.66-5.35a.52.52 0 1 1 .22 1l-24.66 5.37zM20.25 62.64a.53.53 0 0 1-.51-.41.52.52 0 0 1 .4-.62l15.56-3.37a.52.52 0 0 1 .22 1l-15.56 3.39zM21.74 69.5a.52.52 0 0 1-.11-1l24.66-5.35a.53.53 0 0 1 .62.4.52.52 0 0 1-.4.62l-24.66 5.32zM23.22 76.35a.53.53 0 0 1-.51-.41.52.52 0 0 1 .4-.62l20.48-4.43a.53.53 0 0 1 .62.4.52.52 0 0 1-.4.62l-20.48 4.43zM60.81 32.32a.53.53 0 0 1-.51-.41.52.52 0 0 1 .4-.62l20.72-4.48a.52.52 0 0 1 .22 1l-20.72 4.5zM62.3 39.18a.53.53 0 0 1-.51-.41.52.52 0 0 1 .4-.62l24.66-5.34a.52.52 0 1 1 .22 1l-24.66 5.36z"
        />
        <path
            d="M66.12 74.32c-1.68.36-6 4.92-6 4.92l-10.45-48.4s4.28-4.56 6-4.92z"
            fill="#edeff5"
        />
        <circle
            className="book-round-illustration_svg__eds-book-open-cls-6"
            cx={65.35}
            cy={59.48}
            r={28.6}
        />
        <path
            className="book-round-illustration_svg__eds-book-open-cls-4"
            d="M95.26 57.4a30 30 0 1 0-29.95 32.06c.7 0 1.41 0 2.12-.07A30 30 0 0 0 95.26 57.4zm-28 29.23a27.22 27.22 0 1 1-3.78-54.3c.64 0 1.28-.07 1.91-.07a27.22 27.22 0 0 1 1.87 54.37z"
        />
        <path
            className="book-round-illustration_svg__eds-book-open-cls-4"
            d="M109.19 100.73a1.78 1.78 0 0 1-1.17-.43L85.51 80.72A1.79 1.79 0 1 1 87.85 78l22.51 19.6a1.8 1.8 0 0 1 .18 2.52 1.78 1.78 0 0 1-1.35.61z"
        />
        <rect
            className="book-round-illustration_svg__eds-book-open-cls-2"
            x={99.53}
            y={80.8}
            width={8.51}
            height={26.93}
            rx={1.79}
            ry={1.79}
            transform="rotate(-48.7 104.234 94.573)"
        />
        <circle cx={65.42} cy={59.53} r={13.97} fill="#28a865" />
        <path
            className="book-round-illustration_svg__eds-book-open-cls-6"
            d="M58.68 59.26a1.15 1.15 0 0 0-1.62 1.63l5.5 5.5a1.15 1.15 0 0 0 1.68-.06l9.63-11a1.15 1.15 0 0 0-1.73-1.51L63.32 63.9z"
        />
    </svg>
);

BookRoundIllustrationSvg.displayName = 'BookRoundIllustrationSvg';
export default BookRoundIllustrationSvg;
